import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { KompisProductList, KompisProductListTotalPrice } from '@inter-ikea-kompis/react-components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useKompis } from '../contexts';
import { useCountryCode, useIsKiosk, useLanguageCode } from '../contexts/environment';
import { getAppState } from '../store/app/selectors';
import { getStoreAvailabilities } from '../utils';
import { getZipAvailability } from '../utils/zip';
export default ({ products, shoppingProducts, includedProducts }) => {
    const isKiosk = useIsKiosk();
    const countryCode = useCountryCode();
    const languageCode = useLanguageCode();
    const { translations, dexfAppSettings } = useKompis();
    const { storeId, stores, zipCode } = useSelector(getAppState);
    const [storeAvailabilities, setStoreAvailability] = useState();
    const [zipAvailabilities, setZipAvailabilities] = useState();
    useEffect(() => {
        if (storeId && products && stores.some(store => store.id === storeId)) {
            getStoreAvailabilities(products, storeId, dexfAppSettings).then(result => {
                setStoreAvailability(result);
            });
        }
        else {
            setStoreAvailability(undefined);
        }
    }, [storeId, products, stores, languageCode, countryCode, dexfAppSettings]);
    useEffect(() => {
        if (zipCode && products) {
            getZipAvailability(zipCode, products, dexfAppSettings).then(result => {
                setZipAvailabilities(result);
            });
        }
        else {
            setZipAvailabilities(undefined);
        }
    }, [countryCode, languageCode, products, dexfAppSettings, zipCode]);
    return (_jsxs(_Fragment, { children: [_jsx(KompisProductList, { shoppingProducts: shoppingProducts, theme: useKompis().theme, translations: translations.kompis, settings: dexfAppSettings, includedProducts: includedProducts, storeAvailabilities: storeAvailabilities, storeId: storeId, stores: stores, zipAvailabilities: zipAvailabilities, disableLinks: isKiosk }), _jsx(KompisProductListTotalPrice, { shoppingProducts: shoppingProducts, theme: useKompis().theme, settings: dexfAppSettings, translations: translations.kompis })] }));
};
//# sourceMappingURL=KompisProductList.js.map